/**
 * Sets a cookie with the specified name, value, and duration (in seconds).
 */
const setCookie = (name: string, value: string|number, expiration: number|Date) => {
  const expires = expiration instanceof Date
    ? expiration.toUTCString()
    : new Date(Date.now() + expiration * 1000).toUTCString();

  const secure = document.location.protocol === 'https:' ? '; Secure' : '';

  document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Strict${secure}`;
}

const hasCookie = (name: string): boolean => {
  const cookies = document.cookie.split('; ')
  const cookie = cookies.find((c) => c.startsWith(`${name}=`))

  return cookie?.length > 0;
}

const getCookie = (name: string): string | null => {
  const cookies = document.cookie.split('; ');
  const cookie = cookies.find(c => c.startsWith(`${name}=`));

  return cookie ? decodeURIComponent(cookie.split('=')[1]) : null;
}

const deleteCookie = (name: string): void => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
}

export { setCookie, hasCookie, getCookie, deleteCookie }
